var render = function render(){var _vm=this,_c=_vm._self._c;return _c('product-certification-badge',{attrs:{"certification":_vm.certificationObject,"certificationName":_vm.certificationName}})
}
var staticRenderFns = []

export { render, staticRenderFns }